import { render, staticRenderFns } from "./columns-filter.vue?vue&type=template&id=28266021&scoped=true&"
import script from "./columns-filter.vue?vue&type=script&lang=js&"
export * from "./columns-filter.vue?vue&type=script&lang=js&"
import style0 from "./columns-filter.vue?vue&type=style&index=0&id=28266021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28266021",
  null
  
)

export default component.exports